module.exports = __webpack_public_path__ + "media/admin/cs_publication_request_001_lg-68bc4dfd.png";